var map = {
	"./en_US.json": 1181,
	"./vi_VN.json": 1182,
	"./zh_CN.json": 1183
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1180;


//////////////////
// WEBPACK FOOTER
// ./src nonrecursive ^\.\/\w+_\w+\.json$
// module id = 1180
// module chunks = 17